// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__c1Y_e","imageUploader":"EGiftCard_imageUploader__2Cvr8"};